import { createContext, useContext } from 'react'

export const JobContext = createContext()

export function useJob() {
  return useContext(JobContext)
}